<template>
  <div class="page_all">
    <div class="return_link"></div>   
    <div class="page_header">
      <div class="title">プッシュ通知</div>
      <div>
        <button class="btn_plus" v-on:click="pushAdd()">＋</button>
      </div>
    </div>
    <div class="area_radios_div">
      <div class="area_radio_div">
        <input class="area_radio_input" name="template" id="0" type="radio" value="0" v-model="templateFlg" @change="changeRadio()">
        <label class="area_radio_label" for='0'>
            通知履歴
        </label>
      </div>
      <div class="area_radio_div">
        <input class="area_radio_input" name="template" id="1" type="radio" value="1" v-model="templateFlg" @change="changeRadio()">
        <label class="area_radio_label" for='1'>
            テンプレート
        </label>
      </div>
    </div>
    <div class="pager_div">
      <span class="pager_no_span">{{ pagerCnt * pageNo +1 }}-{{ pagerCnt * pageNo + (pushList ? pushList.length : 0) }}件/{{ totalPushListCnt }}件</span>
      <span class="pager_span" v-if="pageNo > 0" @click="pageDown()">＜前へ</span>
      <span class="pager_space" v-else></span>
      <span class="pager_span" v-if="pageNo < (pushList ? pushListCnt - 1 : 0)" @click="pageUp()">次へ＞</span>
      <span class="pager_space" v-else></span>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_push_name">管理名、管理メモ</th>
            <th class="th_title">通知タイトル</th>
            <th class="th_area">対象地域</th>
            <th v-if="templateFlg == 0" class= "th_datetime">送信日時、作成日時</th>
            <th v-else class= "th_datetime">作成日時</th>
            <th class="th_status">状態</th>
            <th class="th_delete" v-if="templateFlg ==  1">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="push in pushList ? pushList : pushList" v-bind:key="push.push_id">
            <td class="td_push_name">
              <router-link v-on:click.native="pushUpdate(push.push_id, push.template_flg)" to="">{{ push.notification_name }}</router-link>
            </td>
            <td class="td_title">{{ push.push_title }}</td>
           <template v-if="push.tab_active == 1">
              <template v-if="push.areas">
                <td v-if="push.areas.split(', ').length == 1" class="td_area">
                  <div class="area_label">{{ push.areas.split(', ')[0] }}</div>
                </td>
                <td v-else-if="push.areas.split(', ').length == 2" class="td_area">
                  <div class="area_label">{{ push.areas.split(', ')[0] }}</div>
                  <div class="area_label">{{ push.areas.split(', ')[1] }}</div>
                </td>
                <td v-else class="td_area">
                  <div class="area_label">{{ push.areas.split(', ')[0] }}</div>
                  <div class="area_label">{{ push.areas.split(', ')[1] }}...</div>
                  <div class="area_label">計{{ push.areas.split(', ').length }}地域へ送信</div>
                </td>
              </template>
              <template v-else>
                <td></td>
              </template>
            </template>
            <template v-else>
              <template v-if="push.group_area_ids.length > 0">
                <td v-if="push.group_area_ids.length == 1" class="td_area">
                  <div class="area_label">{{ areaNameFromAreaId(push.group_area_ids[0]) }}</div>
                </td>
                <td v-else-if="push.group_area_ids.length == 2" class="td_area">
                  <div class="area_label">{{ areaNameFromAreaId(push.group_area_ids[0]) }}</div>
                  <div class="area_label">{{ areaNameFromAreaId(push.group_area_ids[1]) }}</div>
                </td>
                <td v-else class="td_area">
                  <div class="area_label">{{ areaNameFromAreaId(push.group_area_ids[0]) }}</div>
                  <div class="area_label">{{ areaNameFromAreaId(push.group_area_ids[1]) }}...</div>
                  <div class="area_label">計{{ push.group_area_ids.length }}地域へ送信</div>
                </td>
              </template>
              <template v-else>
                <td></td>
              </template>
            </template>
            <template v-if="templateFlg == 0">
              <td v-if="push.status == 0">
                <span v-if="push.create_date != ''">{{ push.create_date | moment('YYYY年MM月DD日 HH時mm分ss秒') }}</span>
              </td>
              <td v-else>
                <span v-if="push.push_datetime != ''">{{ push.push_datetime | moment('YYYY年MM月DD日 HH時mm分ss秒') }}</span>
                <span v-else></span>
              </td>
              <td v-if="push.status == 0" class="td_status">下書き</td>
              <td v-else-if="push.status == 1" class="td_status">送信済み</td>
              <td v-else-if="push.status == 2" class="td_status">送信中</td>
              <td v-else-if="push.status == 3" class="td_status">送信失敗</td>
            </template>
            <template v-else>
              <td v-if="push.status == 0">
                <span v-if="push.create_date != ''">{{ push.create_date | moment('YYYY年MM月DD日 HH時mm分ss秒') }}</span>
              </td>
              <td v-else>
                <span v-if="push.push_datetime != ''">{{ push.push_datetime | moment('YYYY年MM月DD日 HH時mm分ss秒') }}</span>
                <span v-else></span>
              </td>
              <td class="td_status">テンプレート</td>
              <td class="td_delete">
                <button class="btn_delete" @click="deletePush(push)">☓</button>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      pushList: null,
      pushListCnt: 0,
      templateFlg: 0,
      pageNo: 0,
      pagerCnt: 10,
      totalPushListCnt: 0,
      areas: null,
    }
  },
  async mounted() {
    // テンプレートよりの戻り
    console.log("test")
    console.log("StatePushTemplateUpdateFlg: " + this.$store.getters.getStatePushTemplateUpdateFlg)
    if (this.$store.getters.getStatePushTemplateUpdateFlg) {
      this.templateFlg = this.$store.getters.getStatePushTemplateUpdateFlg
    }
    this.$store.commit('setStatePushTemplateUpdateFlg', null)

    // storeテンプレートフラグリセット
    this.$store.commit('setStateTemplateFlg', null)

    this.getAreaList()
    this.getPushList()

    // keep scrop position
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     const positionY = sessionStorage.getItem('pushPositionY')
    //     scrollTo(0, positionY)
    //   }, 500)
    // })
  },
  methods: {
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      this.areas = response.data
      console.log("aaaaaaa")
      console.log(response)
      console.log("bbbbbbb")
      // console.log(this.areas.filter(a => a.area_id == 36757)[0]['area_name'])
    },
    changeRadio: function() {
      this.pageNo = 0

      this.getPushList()
    },
    pageDown: function() {
      this.pageNo -= 1

      this.getPushList()
    },
    pageUp: function() {
      this.pageNo += 1

      this.getPushList()
    },
    async getPushList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'push/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          template_flg: this.templateFlg,
          page_no: this.pageNo
        }
      })

      console.log(response.data)
      
      this.pushList = response.data.push_list
      this.totalPushListCnt = response.data.total_push_cnt,
      this.pushListCnt = response.data.push_list_cnt,
      this.templateFlg = response.data.template_flg

      console.log("pushList areas")
      console.log(this.pushList.map(x => x.group_area_ids))
    },
    pushAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'pushNotificationDetail' })
    },
    pushUpdate: function(push_id, templateFlg) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // テンプレートフラグ
      this.$store.commit('setStateTemplateFlg', templateFlg)
      // PushIdをStoreにセット
      this.$store.commit('setStatePushId', push_id)
      this.$router.push({ name: 'pushNotificationDetail' })
    },
    async deletePush(push) {
      const result = await this.$refs.deleteDialog.asyncShow(`${push.notification_name}を削除してよろしいですか？`);
      console.log(result)
      if (!result) {
        return;
      }

      try {
        // push.areas: カンマ区切りarea名, push.group_area_ids: area_id list
        const areas = push.tab_active == 1 
          ? push.areas  ? push.areas.split(', ') : []
          : this.areas.filter(area => push.group_area_ids.indexOf(area.area_id) != -1).map(a => a.area_name)
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'push/del', {
          push_id: push.push_id,
          areas: areas
        })
      } catch(err) {
        this.message = err.response.data.errorMessage
      }

      this.getPushList()
    },
    // areaNameFromAreaId: function(value) {
    //   // console.log(value)

    //   if(this.areas) {
    //     return this.areas.filter(a => a.area_id == value)[0]['area_name']
    //   } else {
    //     return null
    //   }
    // }
  },
  computed: {
    // sortedPushListByCreateDate() {
    //   if (this.pushList) {
    //     var templateList = this.pushList.filter(push => push.template_flg == 1)
    //     return templateList.sort((a, b) => {
    //       return a.create_date < b.create_date ? 1 : -1
    //     })
    //   } else {
    //     return null
    //   }
    // },
    areaNameFromAreaId: function() {
      return function(value) {
        if(this.areas) {
          var area = this.areas.filter(a => a.area_id == value)
          console.log(area)
          if (area.length > 0) {
            var areaName = area[0]['area_name']
          }

            return areaName 
        } else {
          return null
        }
      }
    },
  }
  // watch: {
  //   hogeList: function() {
  //     console.log("test")
  //     this.$nextTick(() => {
  //         var positionY = sessionStorage.getItem('positionY')
  //         scrollTo(0, positionY);
  //         setTimeout(function(){
  //             scrollTo(0, positionY);
  //         }, 500);
  //     })
  //   }
  // },
}
</script>

<style scoped>
.area_radios_div {
  display: flex;
  margin: 0 0 0 30px;
}
.area_radio_div {
  margin: 0 10px 0 0;
  font-size: smaller;
}
.area_radio_label {
  margin: 2px 0 0 0;
}
table th.th_push_name {
  width: 190px;
  text-align: left;
  padding-left: 10px;
}
table th.th_title {
  width: 310px;
  text-align: left;
  padding-left: 10px;
}
table th.th_area {
  width: 220px;
  text-align: left;
  padding-left: 10px;
}
table th.th_status {
  width: 120px;
  text-align: center;
}
.th_delete {
  width: 50px;
}
table th.th_datetime {
  width: 260px;
  text-align: center;
}
table td {
  word-break: break-all;
}
table td.td_push_name, td.td_title, td.td_area {
  text-align: left;
  padding-left: 10px;
}
table td.td_status {
  text-align: center;
}
.area_label {
  text-align: left;
}
.pager_div {
  display: flex;
  float: right;
}
.pager_no_span {
  font-size: smaller;
}
.pager_span {
  margin: 0 0 0 10px;
  font-size: smaller;
  cursor: pointer;
}
.pager_space {
  margin-left: 40px;
}
</style>